import styled from "styled-components";

export const LightIntrisecDefaultBox = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    transition: background-color, box-shadow 0.15s ease;
    /* display: flex; */
    /* $bulb-classic-bg */
    background-color: hsl(30, 88%, 68%);;
    box-shadow:
        hsla(30, 100%, 89%, 0.659) 0.5px 1px 0px 0px inset,
        hsla(30, 75%, 60%, 0.125) 1px 1px 1px 1px inset;
    /* $bulb-classic-dropped-shadow */
    filter: blur(0.1px) drop-shadow(0px 1px 2px hsl(30, 65%, 43%));
`;
